<template>
  <div class="transaction-store-table">
    <b-row>
      <b-col
        md="12"
        lg="12"
        sm="12"
      >
        <b-table-simple class="table-bordered table-hover tbody-hover">
          <b-thead>
            <b-tr>
              <b-th class="text-center">STT</b-th>
              <b-th class="text-center">Cửa hàng</b-th>
              <b-th class="text-center">Mã tài khoản</b-th>
              <b-th class="text-center">Tên tài khoản</b-th>
              <b-th class="text-center">Số dư đầu kỳ</b-th>
              <b-th class="text-center">Tổng thu</b-th>
              <b-th class="text-center">Tổng chi</b-th>
              <b-th class="text-center">Số dư cuối kỳ</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="loading">
            <b-tr>
              <b-td colspan="8">
                <vcl-table
                  :speed="10"
                  :animate="true"
                  :columns="8"
                />
              </b-td>
            </b-tr>
          </b-tbody>
          <b-tbody v-else-if="items.dataset && items.dataset.length === 0">
            <b-tr>
              <b-td
                colspan="8"
                class="text-center"
              >
                Không có dữ liệu
              </b-td>
            </b-tr>
          </b-tbody>
          <template v-else>
            <b-tbody
              v-for="(store, index) in items.dataset"
              :key="store.storeId"
            >
              <b-tr
                v-for="item in store.summaries"
                :key="item.accountantId"
              >
                <b-td
                  :rowspan="store.summaries.length + 1"
                  class="text-center align-middle"
                  v-show="isShowRow(store.summaries, item)"
                  style="width: 20px"
                >
                  {{ index + 1 + getOffsetItem }}
                </b-td>
                <b-td
                  :rowspan="store.summaries.length + 1"
                  class="text-left align-middle"
                  v-show="isShowRow(store.summaries, item)"
                  style="width: calc (20% - 20px)"
                >
                  {{ store.storeName }}
                </b-td>
                <b-td
                  class="text-left align-middle"
                  style="width: 15%"
                >
                  {{ item.accountantCode }}
                </b-td>
                <b-td
                  class="text-left align-middle"
                  style="width: 20%"
                >
                  {{ item.accountantName }}
                </b-td>
                <b-td
                  class="text-right align-middle"
                  style="width: 11%"
                >
                  {{ convertPrice(item.openingBalance) }}
                </b-td>
                <b-td
                  class="text-right align-middle"
                  style="width: 11%"
                >
                  <router-link :to="{
                      name: 'list-transaction',
                      params: {
                        searchProps: {
                          storeId: store.storeId,
                          fromDate: apiParams.fromDate,
                          toDate: apiParams.toDate,
                          type: '1',
                          accountantCode: item.accountantCode,
                        },
                        mode: 'cash',
                      },
                    }">
                    {{ convertPrice(item.cashIn) }}
                  </router-link>
                </b-td>
                <b-td
                  class="text-right align-middle"
                  style="width: 11%"
                >
                  <router-link :to="{
                      name: 'list-transaction',
                      params: {
                        searchProps: {
                          storeId: store.storeId,
                          fromDate: apiParams.fromDate,
                          toDate: apiParams.toDate,
                          type: '2',
                          accountantCode: item.accountantCode,
                        },
                        mode: 'cash',
                      },
                    }">
                    {{ convertPrice(item.cashOut) }}
                  </router-link>
                </b-td>
                <b-td
                  class="text-right align-middle"
                  style="width: 12%"
                >
                  {{ convertPrice(item.closingBalance) }}
                </b-td>
              </b-tr>
            </b-tbody>
            <b-tbody>
              <b-tr>
                <b-td
                  colspan="4"
                  class="text-right align-middle font-weight-bolder"
                  style="font-weight: 600; color: '#181c32'"
                >
                  <span>Tổng</span>
                </b-td>
                <b-td class="text-right align-middle font-weight-bolder">
                  <span>{{ convertPrice(sumAmount('openingBalance')) }}</span>
                </b-td>
                <b-td class="text-right align-middle font-weight-bolder">
                  <span>{{ convertPrice(sumAmount('cashIn')) }}</span>
                </b-td>
                <b-td class="text-right align-middle font-weight-bolder">
                  <span>{{ convertPrice(sumAmount('cashOut')) }}</span>
                </b-td>
                <b-td class="text-right align-middle font-weight-bolder">
                  <span>{{ convertPrice(sumAmount('closingBalance')) }}</span>
                </b-td>
              </b-tr>
            </b-tbody>
          </template>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex';
import reduce from 'lodash/reduce';
import { VclTable } from 'vue-content-loading';

export default {
  name: 'TransactionStoreTable',
  components: {
    VclTable,
  },
  props: {
    items: {
      type: Object,
      default: () => ({
        dataset: [],
        total: 0,
        pages: 1,
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    apiParams: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getOffsetItem() {
      return (this.apiParams.page - 1) * this.apiParams.pageSize;
    },
  },
  methods: {
    /**
     * Check if row should be shown (for rowspan handling)
     */
    isShowRow(listData, item) {
      return findIndex(listData, ['accountantId', item.accountantId]) === 0;
    },

    /**
     * Calculate sum for a specific data key across all items
     */
    sumAmount(dataKey) {
      if (!this.items.dataset) return 0;

      const dataList = this.items.dataset;
      let sum = 0;

      for (let index = 0; index < dataList.length; index++) {
        const element = dataList[index];
        sum += reduce(
          element.summaries,
          (sum, item) => {
            return sum + parseFloat(item[dataKey]);
          },
          0,
        );
      }

      return sum;
    },

    /**
     * Format price for display
     */
    convertPrice(number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-store-table {
  .table tbody + tbody {
    border-top: unset !important;
  }
}
</style>
